module.exports = __webpack_public_path__ + "static/img/closea.08babd0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/closea.png
// module id = 7yyL
// module chunks = 1